import React from "react";
import WinnerCard from "./WinnerCard";
import "../../../../../../styles/ambassadorChallenge/wallOfFame.scss";


const WeekItem: React.FC<WeekData> = ({
  challenge_id,
  title,
  period_start,
  period_end,
  duration_type,
  winners,
}) => {

    const formatDate = (timestamp: string | null): string | null => {
    if (!timestamp) return null;

    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
}

  return (
    <div className="wof-week">
      <div className="wof-week-header">
        <div className="trophy">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_11208_71087)">
              <path
                d="M6.66406 17.5H13.3307"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14.167V17.5003"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.83594 3.33301H14.1693"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.1693 3.33301V9.99967C14.1693 11.1047 13.7303 12.1646 12.9489 12.946C12.1675 13.7274 11.1077 14.1663 10.0026 14.1663C8.89754 14.1663 7.83773 13.7274 7.05633 12.946C6.27492 12.1646 5.83594 11.1047 5.83594 9.99967V3.33301"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.16667 9.16634C5.08714 9.16634 5.83333 8.42015 5.83333 7.49967C5.83333 6.5792 5.08714 5.83301 4.16667 5.83301C3.24619 5.83301 2.5 6.5792 2.5 7.49967C2.5 8.42015 3.24619 9.16634 4.16667 9.16634Z"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.8307 9.16634C16.7512 9.16634 17.4974 8.42015 17.4974 7.49967C17.4974 6.5792 16.7512 5.83301 15.8307 5.83301C14.9103 5.83301 14.1641 6.5792 14.1641 7.49967C14.1641 8.42015 14.9103 9.16634 15.8307 9.16634Z"
                stroke="#4593ED"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_11208_71087">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="week-left">
          <div className="week-title">{title}</div>
          <div className="week-sub">
            {formatDate(period_start)} - {formatDate(period_end)}  
            {/* {week.participants.toLocaleString()} participants · */}
            {/* {" "} <span className="distributed-amount">${week.distributedAmount ?? 0}</span> Distributed */}
          </div>
        </div>
      </div>

      <div className="wof-week-body">
        {winners.map((w) => (
          <WinnerCard key={w.referrer_id} {...w} />
        ))}
      </div>
    </div>
  );
};

export default WeekItem;
